import { Alert, Alignment, Button, Classes, Dialog, FormGroup, HTMLTable, InputGroup, Tag, } from "@blueprintjs/core";
import { DateInput } from "@blueprintjs/datetime";
import { MDBBtn, MDBCol, MDBRow, } from "mdbreact";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as moment from "moment";
import * as React from "react";
import { api } from "../../api";
import { IAgendamento, ILogSefa, ISefaArquivos, newEmpresa, newIAgendamento, newILogSefa, } from "../../model";
import { IEmpresa } from "../../model";
import { AppStore } from "../../stores/AppStore";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { TransmissaoStore } from "../../stores/sefip/TransmissaoStore";
import { toast } from "react-toastify";
import { formatMillisToHMS, getDiaSemana, getMomentFormatter, isExpired } from "../../utils";
import { formatCnpj } from "../../utils";
import { EmpresaSelect, filterEmpresa, renderEmpresa, } from "../empresa/EmpresaSelect";
import { DateRangePicker } from "../utils/DateRangePicker";
import { Pager } from "../utils/Pager";
import { BootstrapTable, SearchField, TableHeaderColumn, } from "react-bootstrap-table";
import ReactJson from "react-json-view";
import MomentLocaleUtils from "react-day-picker/moment";
import { DateRangePickerSped } from "../utils/DateRangePickerSped";
import { SefaStore } from "../../stores/sefa/SefaStore";
import { sortBy } from "../../utils";
import { getTag } from "../utils/getStatus";
import LoadingModal from "../loading/LoadingModal";
import { AppIcon } from "../utils/AppIcon";

interface Props {}

interface State {
  date1: string;
  date2: string;
  date3: string;
  date4: string;
  dateRealizar: string;
  filtro: string;
  date: any;
  dateSolicitacao: any;
  dateRealizaDia: any;
  allCheck: string;
  list: any[];
  listEmpresas: any[];
}

@observer
export class SefaPage extends React.Component<Props, State> {

  obs = observable({
    selectedPeriod: [] as any,
    selectedPeriodSolicitacao: [] as any,
    selectedEmpresa: newEmpresa() as IEmpresa,
    programarSolicitacoes: false as boolean,
    verSolicitacoes: false as boolean,
    allCheckToogle: false as boolean,
    open_logs: false as boolean,
    block_select: false as boolean,
    data_download: new Date() as Date,
    is_dataDownload: false as boolean,
    erros_sefa: [] as any[],
    agora: false as boolean,
    uuid: "" as string,
    arquivosSefa: [] as any,
    errosSefa: newILogSefa() as ILogSefa,
    current_page: 1 as number,
    detalhes_page: 1 as number,
    agendamento_page: 1 as number,
    solicitacao_id: "" as string,
    log_erros: [] as string[],
    loading: false as boolean,
    loading_inner: false as boolean,
    selectedEmpresaDetalhes: newEmpresa() as IEmpresa,
    salvar_sefa: false as boolean,
    open_agendamentos: false as boolean,
    open_create_agendamento: false as boolean,
    agendamento: newIAgendamento() as IAgendamento,
    sefa_new: false as boolean,
    link_img: "" as string,
    msg_erro: "" as string,
    open_view_img: false as boolean,
  })

  constructor(props) {
    super(props);
    AppStore.setTitle("Solicitações SEFA");

    this.obs.selectedEmpresa = newEmpresa();

    this.state = {
      date1: "",
      date2: "",
      date3: "",
      date4: "",
      dateRealizar: "",
      filtro: "",
      date: [],
      dateSolicitacao: [],
      allCheck: "",
      list: [],
      listEmpresas: [],
      dateRealizaDia: null
    }

    SefaStore.obs.imps = []

  }

  async componentDidMount() {
    this.setState({ list: [] });
    this.setState({ listEmpresas: [] });
  }

  handleDateChange = (val: any) => {
    var string = val.toString();
    var array = string.split(",");

    this.setState({ date1: moment(array[0]).format("YYYY-MM-DD") });
    this.setState({ date2: moment(array[1]).format("YYYY-MM-DD") });

    this.setState({ date: val });
    this.obs.selectedPeriod = val;
  };

  handleDateSolicitacaoChange = (val: any) => {
    var string = val.toString();
    var array = string.split(",");

    this.setState({ date3: moment(array[0]).format("YYYY-MM-DD") });
    this.setState({ date4: moment(array[1]).format("YYYY-MM-DD") });

    this.setState({ dateSolicitacao: val });
    this.obs.selectedPeriodSolicitacao = val;
  };

  handleDateRealizarChange = (val: Date) => {
    var string = val.toString();

    var dataAgora = moment().format("YYYY-MM-DD");
    var date1 = moment(string).format("YYYY-MM-DD");

    if (date1 <= dataAgora) {

      toast.warning('Você não pode selecionar uma data inferior ao dia de hoje.', {});
      this.setState({ dateRealizaDia: null, dateRealizar: "" });

      return;

    } else {
      this.setState({ dateRealizaDia: val, dateRealizar: moment(string).format("YYYY-MM-DD") });
    }

  };

  createCustomSearchField = (props) => {
    return (
      <SearchField
        className="input-filter"
        defaultValue={props.defaultSearch}
        placeholder="Filtrar (Empresa, Protocolo)"
      />
    );
  };

  createCustomSearchFieldSol = (props) => {
    return (
      <SearchField
        className="input-filter input-filter-sefa"
        defaultValue={props.defaultSearch}
        placeholder="Filtrar (Razão Social, CNPJ)"
      />
    );
  };

  customSearchAgendamento = (props) => {
    return (
      <SearchField
        className="input-filter input-filter-sefa-agendamento"
        defaultValue={props.defaultSearch}
        placeholder="Filtrar (Razão Social, CNPJ)"
      />
    );
  };

  handleBuscaClick = async () => {

    if (!this.obs.selectedEmpresa.cnpj) {
      toast.warning('Você precisa selecionar uma empresa para filtrar.', {});
      return
    }

    if (!this.state.date1 || this.state.date1 == "Data inválida") {
      toast.warning('Selecione o período das solicitações.', {});
      return
    }

    if (!this.state.date2 || this.state.date2 == "Data inválida") {
      toast.warning('Selecione o período de agendamento.', {});
      return
    }

    this.setState({ list: [] });
    this.obs.loading = true;

    var empresa = this.obs.selectedEmpresa.cnpj;
    var sefa_new = AppStore.obs1.usuario.conta.sefa_new;
    var date1 = this.state.date1;
    var date2 = this.state.date2;

    await SefaStore.length_arquivos(empresa, date1, date2, sefa_new);
    await SefaStore.setBuscaLimite(empresa, date1, date2, this.obs.current_page, 50, sefa_new);

    this.obs.loading = false

  };

  handleBuscaDetalhe = async (
    cnpj: string,
    filtro: string,
    date1: string,
    date2: string,
    sol_id: any,
    sefa_new: boolean
  ) => {
    this.obs.loading = true;
    await SefaStore.setBuscaProgramada(cnpj, filtro, date1, date2, sol_id, sefa_new);
    this.obs.verSolicitacoes = false;
    this.obs.loading = false;
    SefaStore.obs.detalhesSolicitacao = false;
  };

  handleLogsBotSEFA = async (id_solicitacoes: any, sefa_new: boolean) => {

    await SefaStore.buscaLogsBotSEFA(id_solicitacoes, sefa_new);

    if (SefaStore.obs.logs_robo.length > 0) {

      this.obs.open_logs = true;

    }

  };

  handleCheckEmpresaChange = async (row, checked) => {

    if (checked) {

      this.setState(state => { state.listEmpresas.push(row.cnpj) });

    } else {

      let index = this.state.listEmpresas.indexOf(row.cnpj);

      this.state.listEmpresas.splice(index, 1);

    }

  };

  handleCheckEmpresas = async (check, row) => {

    if (check) {

      this.setState({ listEmpresas: row?.map(value => value.cnpj) });

    } else {

      this.setState({ listEmpresas: [] });
    }

  };

  handleDetalhes = async (hist: any) => {
    let h = SefaStore.obs.historico.find(x => x.id == hist.id);
    this.obs.loading_inner = true;
    this.obs.detalhes_page = 1;
    this.obs.selectedEmpresaDetalhes = newEmpresa()

    if (h.pendentes) {
      toast.warning('Nenhum detalhe para exibir, aguarde sua solicitaçãos ser processada.', {});

    } else {
      this.obs.solicitacao_id = hist.id;
      SefaStore.obs.solicitacao = [];
      await SefaStore.buscaDetalheSolicitacaoPaged(this.obs.solicitacao_id, 1, 6, "", hist.sefa_new);
      await SefaStore.length_detalhe(hist.id, hist.sefa_new);
    }

    this.obs.loading_inner = false;

  };

  handleDeleteTarefa = async (id: any, solicitacao_id: any) => {
    this.obs.loading = true;
    await SefaStore.deletaTarefa(id, solicitacao_id);
    this.obs.loading = false;
  };

  handleCloseProgramar = async () => {
    this.obs.programarSolicitacoes = false;
    this.obs.allCheckToogle = false;
    this.setState({ listEmpresas: [] });
    this.setState({ dateRealizaDia: null, dateRealizar: null });
    this.obs.block_select = false;
    this.obs.agora = false
    this.obs.selectedPeriodSolicitacao = []
  };

  isDentroDos5Anos(dataAtualStr: string, dataInicialStr: string): boolean {

    const dataAtual = new Date(dataAtualStr);
    const dataInicial = new Date(dataInicialStr);

    const dataMinima = new Date(dataAtual);

    dataMinima.setFullYear(dataMinima.getFullYear() - 5);

    return dataInicial >= dataMinima && dataInicial <= dataAtual;

  }

  handleProgramarSolicitacoes = async () => {
    const { date3, date4, dateRealizar, listEmpresas } = this.state;
    const { agora } = this.obs;

    const dataFinal = date4;
    const dataRealizar = moment(dateRealizar).format("YYYY-MM-DD");
    const dataAgora = moment().format("YYYY-MM-DD");

    if (listEmpresas.length < 1) {
      toast.warning('Você precisa selecionar as empresas.');
      return;
    }

    if (!date3 || !date4) {
      toast.warning('Você precisa selecionar o período da solicitação.');
      return;
    }

    if ((dataRealizar <= dataFinal) || (agora && dataAgora <= dataFinal)) {
      toast.warning('Você não pode selecionar uma data posterior ao dia da solicitação.');
      return;
    }

    if (!dateRealizar && !agora) {
      toast.warning('Por favor, selecione o campo "Realizar neste momento" ou preencha o campo "Realizar dia" para prosseguir.');
      return;
    }

    if (!this.isDentroDos5Anos(dataAgora, date3)) {
      toast.error("O período informado deve estar dentro dos últimos 5 anos.");
      return;
    }

    try {

      this.obs.programarSolicitacoes = false;
      this.obs.loading = true;

      const payload = {
        data_solicitacao: dateRealizar,
        date1: date3,
        date2: date4,
        list: listEmpresas,
        agora,
        sefa_new: true,
      };

      const resp = await api.post(`/api/sefa`, payload);
      this.obs.erros_sefa = [];

      if (resp.data.ok === false) {
        toast.error(resp.data.msg);
        this.resetStateAfterFailure();
        return;
      }

      if (resp.data.length === 0) {

        EmpresaStore.usuariosEmpresas();
        toast.success('Salvo com sucesso!');
        this.handleCloseProgramar();

      } else {

        this.obs.erros_sefa = resp.data;
        SefaStore.obs.errosSolicitacao = true;
        toast.warning('Solicitação realizada, com ERROS.');
        this.resetStateAfterFailure();

      }

    } catch (error) {

      toast.error('Erro ao programar sua solicitação SEFA, tente novamente mais tarde.');
      this.resetStateAfterFailure();

    } finally {

      this.obs.loading = false;

    }

  };

  resetStateAfterFailure = () => {
    this.obs.allCheckToogle = false;
    this.setState({ listEmpresas: [] });
  };

  renderShowsTotal(start, to, total) {
    return (
      <p style={{ marginLeft: 12 }}>
        Mostrando {start} a {to} de {total} resultados.&nbsp;&nbsp;
      </p>
    );
  }
  handlePageChangeDetalhes = async (page: number) => {
    this.obs.loading = true;
    this.obs.detalhes_page = page;
    this.obs.selectedEmpresaDetalhes = newEmpresa()
    await SefaStore.buscaDetalheSolicitacaoPaged(this.obs.solicitacao_id, page, 6, "", SefaStore.obs.solicitacao[0]?.sefa_new || false);
    this.obs.loading = false;
  };

  handlePageChangeAgendamento = async (page: number) => {
    await SefaStore.solicitacoesPaged(page, 7);
    this.obs.detalhes_page = page;
  };

  handleBuscaSolicitacoesEmpresa = async (page: number) => {
    var empresa = this.obs.selectedEmpresa.cnpj;
    var sefa_new = AppStore.obs1.usuario.conta.sefa_new;
    var date1 = this.state.date1;
    var date2 = this.state.date2;
    await SefaStore.setBuscaLimite(
      empresa,
      date1,
      date2,
      page,
      50,
      sefa_new
    );
  };

  async handleFilterSolicitacoesEmpresa(empresa: any) {
    this.obs.loading = true;
    this.obs.selectedEmpresaDetalhes = empresa
    this.obs.detalhes_page = 1
    await SefaStore.buscaDetalheSolicitacaoPaged(this.obs.solicitacao_id, 1, 6, empresa.cnpj, SefaStore.obs.solicitacao[0]?.sefa_new || false);
    this.obs.loading = false;
  }

  async onClearEmpresa() {
    this.obs.loading = true;
    this.obs.selectedEmpresaDetalhes = newEmpresa()
    this.obs.detalhes_page = 1
    await SefaStore.buscaDetalheSolicitacaoPaged(this.obs.solicitacao_id, 1, 6, "", SefaStore.obs.solicitacao[0]?.sefa_new || false);
    this.obs.loading = false;
  }

  onCloseSolicitacoes() {
    this.obs.verSolicitacoes = false
    this.obs.selectedEmpresaDetalhes = newEmpresa()
  }

  onCloseDetalhesSolicitacoes() {
    SefaStore.obs.detalhesSolicitacao = false
    this.obs.selectedEmpresaDetalhes = newEmpresa()
  }

  handleRowSelect = async (row, checked) => {
    if (checked) {
      this.obs.agendamento.listEmpresas.push(row.cnpj);
    } else {
      let index = this.obs.agendamento.listEmpresas.indexOf(row.cnpj);
      this.obs.agendamento.listEmpresas.splice(index, 1);
    }
  };

  handleRowSelectAll = async (check, row) => {
    if (check) {

      this.obs.agendamento.listEmpresas = row?.map(x => x.cnpj)

    } else {
      this.obs.agendamento.listEmpresas = [];
    }
  };

  handleValidAgendamento() {

    if (this.obs.agendamento.descricao == "") {
      toast.warning('Por favor, preencha a descrição.', {});
      return true
    }

    if (this.obs.agendamento.periodo_selecionado == "") {
      toast.warning('Por favor, selecione um Período de comunicação.', {});
      return true
    }

    if (this.obs.agendamento.periodo_selecionado == "semanal" && this.obs.agendamento.dia == "") {
      toast.warning('Por favor, selecione um dia.', {});
      return true
    }

    if (this.obs.agendamento.listEmpresas.length < 1) {
      toast.warning('Por favor, selecione pelo menos uma empresa.', {});
      return true
    }

    return false
  }

  async handleCreateAgendamento() {

    if (this.handleValidAgendamento()) return

    this.obs.open_create_agendamento = false

    if (this.obs.agendamento.id == "") {

      let data = {
        periodo: this.obs.agendamento.periodo_selecionado,
        dia: this.obs.agendamento.dia,
        empresas: this.obs.agendamento.listEmpresas,
        descricao: this.obs.agendamento.descricao,
        sefa_new: (AppStore.obs1.usuario.conta.sefa_new || false)
      }

      await SefaStore.handleProgramarAgendamento(data)

    } else {

      let data = {
        id: this.obs.agendamento.id,
        periodo: this.obs.agendamento.periodo_selecionado,
        dia: this.obs.agendamento.dia,
        empresas: this.obs.agendamento.listEmpresas,
        descricao: this.obs.agendamento.descricao,
        sefa_new: (AppStore.obs1.usuario.conta.sefa_new || false)
      }

      await SefaStore.handleUpdateAgendamento(data)

    }

    this.obs.agendamento = newIAgendamento()
  }

  async handleCloseAgendamento() {
    this.obs.open_create_agendamento = false
    this.obs.agendamento = newIAgendamento()
  }

  async handleOpenAgendamentos() {
    SefaStore.obs.page_agendamentos = 1
    await SefaStore.handleIndexAgendamentos(1);
    this.obs.open_agendamentos = true
  }

  handlePageAgendamento = async (page: number) => {
    SefaStore.obs.page_agendamentos = page;

    await SefaStore.handleIndexAgendamentos(page);

  };

  async handleOpenHistAgendamentos() {

    this.obs.agendamento_page = 1

    await SefaStore.load();

    this.obs.verSolicitacoes = true

  }

  statusFormatter(sol, sefa_new, width) {

    if (sefa_new) {

      return getTag(sol.status, sol.tipo, sol, width);

    } else if (sol.status) {

      return getTag(sol.status, "", sol, width)

    }

    return ""

  }

  handleErros(row: any) {

    this.obs.erros_sefa = [];

    if (!(row.errors || []).length) return

    this.obs.erros_sefa = row.errors || [];

    SefaStore.obs.errosSolicitacao = true;

  }

  formatDateAdd(cell, row) {

    if (!cell) return ""

    return moment(cell).add({ "hours": 3 }).format("DD/MM/YYYY")

  }

  formatDateSubtract(cell, row) {

    if (!cell) return ""

    return moment(cell).subtract({ "hours": 3 }).format("DD/MM/YYYY")

  }

  async handleDownloadImg(chave: string){

    await SefaStore.downloadImagemError(chave)

  }

  async handleViewImg(chave: string, mensagem: string){

    let resp = await SefaStore.viewImagemError(chave)

    this.obs.link_img = resp

    this.obs.msg_erro = mensagem

    this.obs.open_view_img = true

  }

  handleErrosTask() {

    if (this.obs.log_erros.every(item => typeof item === 'string')) {

      return this.obs.log_erros?.map(x => {

        return <p>{x}</p>;

      })

    }

    return this.obs.log_erros?.flatMap((erro, index) =>

      Object.entries(erro).map(([chave, mensagem]) => {

        return (<p key={chave}>{index + 1}. {mensagem}

          {chave && <>
            &nbsp;&nbsp;
            <AppIcon name="sim_card_download" onClick={() => this.handleDownloadImg(chave)} size={20} style={{ color: "#3579ea", cursor: "pointer" }} />
          </>}
          &nbsp;&nbsp;
          <AppIcon name="visibility" onClick={() => this.handleViewImg(chave, mensagem)} size={20} style={{ color: "#f57115", cursor: "pointer" }} />

        </p>)

    })

    );

  }

  formatMS(cell, row) {

    if(!cell) return ""

    return formatMillisToHMS(cell)

  }

  onCloseErros() {

    SefaStore.obs.errosSolicitacao = false

    this.obs.erros_sefa = []

  }

  render() {
    let niveis_acesso = AppStore.obs1.usuario
      ? AppStore.obs1.usuario.niveis_acesso
      : [""];

    let dayPickerProps = {
      localeUtils: MomentLocaleUtils,
      locale: "pt-br",
    };

    let items = SefaStore.obs.imps?.map(imp => {
      return ({
        arquivos: imp.arquivos,
        cod_folha: imp.cod_folha,
        competencia: imp.competencia,
        cpf: imp.cpf,
        data_agendamento: imp.data_agendamento,
        data_criacao: moment(imp.data_criacao),
        empresa: imp.empresa,
        cnpj: formatCnpj(imp.empresa),
        erro: imp.erro,
        log_erros: imp.log_erros,
        finalizado: imp.finalizado,
        id: imp.id,
        ie: imp.ie,
        nome: imp.nome,
        origem: imp.origem,
        periodo_final: imp.periodo_final,
        periodo_inicial: imp.periodo_inicial,
        prioridade: imp.prioridade,
        protocolo: imp.protocolo,
        status: imp.status,
        tipo: imp.tipo,
        tipo_folha: imp.folha,
        ultima_atualizacao: imp.ultima_atualizacao,
        uuid: imp.uuid,
        automatico: imp.automatico,
        sefa_new: imp.sefa_new,
        ms: imp.ms
      });
    });

    let empresaText = this.obs.selectedEmpresa.razao_social != ""
      ? `${this.obs.selectedEmpresa.razao_social.substring(0, 38)}... (${formatCnpj(this.obs.selectedEmpresa.cnpj)})`
      : "Selecione uma empresa";

    let empresaTextDetalhes = this.obs.selectedEmpresaDetalhes.razao_social != ""
      ? `${this.obs.selectedEmpresaDetalhes.razao_social} (${formatCnpj(this.obs.selectedEmpresaDetalhes.cnpj)})`
      : "Selecione uma empresa";

    let empresas = EmpresaStore.sortedEmpresas?.map(emp => {

      return ({
        _id: emp._id,
        razao_social: emp.razao_social,
        cnpj: emp.cnpj,
        cnpj_formated: formatCnpj(emp.cnpj)
      })

    });

    let logs = SefaStore.obs.logs_robo?.map((sol, index) => {
      let empresa = EmpresaStore.getByCnpj(sol.cnpj);
      if (empresa) {
        return (
          <tr key={index} className="nz-table-actions">
            <td>
              {empresa.razao_social.substring(0, 30)}...
            </td>
            <td>
              {formatCnpj(sol.cnpj)}
            </td>
            <td>
              {sol.erro};
            </td>
          </tr>
        );
      } else {
        return false;
      }
    });

    function handleTipo(automatico) {
      switch (automatico) {
        case true:
          return <span className="new-tag-nav-new">Automático</span>
        default:
          return <span className="new-tag-nav">Manual</span>
      }
    }

    let historico = sortBy(SefaStore.obs.historico, "inserted_at").reverse()?.map(hist => {
      return (
        <tr key={hist.id} className="nz-table-actions">
          <td>
            {moment(hist.data_solicitacao).format("DD/MM/YYYY")}
          </td>
          <td>{moment(hist.date1).format("DD/MM/YYYY")}</td>
          <td>{moment(hist.date2).format("DD/MM/YYYY")}</td>
          <td>
            <b>{hist.total} selecionados</b>
          </td>
          <td>{handleTipo(hist.automatico)}</td>
          <td style={{ textAlign: "center" }}>
            {(hist.errors || []).length ?
              <AppIcon size={22} name="error" style={{ color: "#c15151", cursor: "pointer" }} onClick={() => this.handleErros(hist)} />
              : <></>}
          </td>
          <td style={{ textAlign: "center" }}>
            <AppIcon size={22} name="search" style={{ color: "#3579ea", cursor: "pointer" }} onClick={() => this.handleDetalhes(hist)} />
          </td>
          <td style={{ textAlign: "center" }}>
            <AppIcon size={22} name="list" style={{ color: "#166470", cursor: "pointer" }} onClick={() => this.handleLogsBotSEFA(hist.id, hist.sefa_new)} />
          </td>
        </tr>
      );
    });

    let detalhes = SefaStore.obs.solicitacao?.map(sol => {
      let empresa = EmpresaStore.getByCnpj(sol.cnpj);
      if (empresa) {
        return (
          <tr key={sol.id} className="nz-table-actions">
            <td>
              {empresa.razao_social.length >= 30 ? empresa.razao_social.substring(0, 30) + "..." : empresa.razao_social}
            </td>
            <td>
              {empresa.apelido ? empresa.apelido.length >= 30 ? empresa.apelido.substring(0, 30) + "..." : empresa.apelido : ""}
            </td>
            <td>
              {sol.cnpj ? formatCnpj(sol.cnpj) : ""}
            </td>
            <td>
              {moment(sol.date1).add({ "hours": 3 }).format("DD/MM/YYYY")} -{" "}
              {moment(sol.date2).add({ "hours": 3 }).format("DD/MM/YYYY")}
            </td>
            <td>
              {this.statusFormatter(sol, sol.sefa_new, { width: "100%" })}
            </td>
            <td>
              <Tag
                className="tagConfirmacao tagVerSolici"
                style={{ width: "100%", textAlign: "center" }}
                onClick={() => this.handleBuscaDetalhe(sol.cnpj, "Todos", moment(sol.date1).format("YYYY-MM-DD"), moment(sol.date2).format("YYYY-MM-DD"), sol.id, sol.sefa_new)}
              >
                Ver
              </Tag>
            </td>
            <td>
              <div style={{ cursor: "pointer" }} onClick={() => handleViewDetalhes(sol)}>
                <img src="/images/view.png" width="20px" />
              </div>
            </td>
          </tr>
        );
      } else {
        return null
      }
    }).filter(x => x != null)

    const options = {
      page: 1, // which page you want to show as default
      sizePerPageList: [{
        text: "20",
        value: 20,
      }, {
        text: "50",
        value: 50,
      }, {
        text: "100",
        value: 100,
      }], // you can change the dropdown list for size per page
      sizePerPage: 20, // which size per page you want to locate as default
      pageStartIndex: 1, // where to start counting the pages
      paginationSize: 4, // the pagination bar size.
      prePage: "Ante", // Previous page button text
      nextPage: "Próxima", // Next page button text
      firstPage: "Início", // First page button text
      lastPage: "Última", // Last page button text
      paginationShowsTotal: this.renderShowsTotal, // Accept bool or function
      paginationPosition: "bottom", // default is bottom, top and both is all available
      // hideSizePerPage: true > You can hide the dropdown for sizePerPage
      // alwaysShowAllBtns: true // Always show next and previous button
      // withFirstAndLast: false > Hide the going to First and Last page button
      searchField: this.createCustomSearchField,
    };

    const options_soli = {
      searchField: this.createCustomSearchFieldSol,
    };

    const options_agendamentos = {
      searchField: this.customSearchAgendamento,
    };

    // const handleDownloadArquivo = async (row: ISefaArquivos) => {
    //   await TransmissaoStore.downloadArquivo(this.obs.uuid, row.nome, row.id);
    // };
    // const handleVisualizaArquivo = async (row: ISefipArquivos) => {
    //   await SefaStore.PdfViewTransmissao(this.obs.uuid, row.id);
    // };
    // const handleViewDetalhes = async (row: ILogSefa) => {
    //   this.obs.errosSefa = row;
    //   this.obs.erros = await TransmissaoStore.consultaErro(row.uuid);
    //   SefaStore.obs.viewDetalhes = true;
    // };
    const handleDownloadArquivo = async (row: ISefaArquivos, sefa_new) => {

      if (sefa_new) {

        await SefaStore.downloadArquivoSefa(row.nome, row.id);

      } else {

        await TransmissaoStore.downloadArquivo(this.obs.uuid, row.nome, row.id);

      }

    };

    const handleViewDetalhes = async (row: ILogSefa) => {
      this.obs.errosSefa = row;

      this.obs.log_erros = [];

      if (AppStore.obs1.usuario.conta.sefa_new) {

        this.obs.log_erros = row.log_erros || [];

      } else {

        this.obs.log_erros = await TransmissaoStore.consultaErro(row.uuid);

      }

      SefaStore.obs.viewDetalhes = true;

    };

    const handleViewArquivos = (row: ILogSefa, sefa_new: boolean) => {

      if (isExpired(row.data_agendamento)) {
        toast.error("Arquivos indisponíveis. Prazo de 90 dias expirado.")
        return
      }

      this.obs.sefa_new = sefa_new;

      if (sefa_new) {

        if (!row.arquivos || row.arquivos.length == 0) {

          toast.warning('Nenhum arquivo foi encontrado!', {});

        } else {

          this.obs.arquivosSefa = []
          this.obs.uuid = row.id;

          row.arquivos.map(value => {
            let string = value.split('-')
            let filename = string.slice(2).join('-');
            this.obs.arquivosSefa.push({ nome: filename, id: value })
          });

          SefaStore.obs.viewArquivos = true;

        }

      } else {

        if (!row.arquivos || row.arquivos.length == 0) {

          toast.warning('Nenhum arquivo foi encontrado!', {});

        } else {

          this.obs.arquivosSefa = row.arquivos;
          this.obs.uuid = row.uuid;
          SefaStore.obs.viewArquivos = true;

        }
      }

    };

    const handleDownloadAll = async (sefa_new) => {

      if (sefa_new) {

        try {
          const id = this.obs.uuid;
          await SefaStore.download_sefa_zip(id, this.obs.arquivosSefa.map((file) => file.id));
        } catch (error) {
          toast.error("Erro ao realizar o download. Tente novamente.");
        }
      } else {
        try {
          const uuid = this.obs.uuid || "default_uuid";
          const empresa = this.obs.errosSefa?.empresa || "default_empresa";
          await TransmissaoStore.downloadArquivosAll(uuid, empresa, "");
        } catch (error) {
          toast.error("Erro ao realizar o download. Tente novamente.");
        }
      }

    };

    function buttonFormatterDetalhes(cell, row) {
      return (
        <>
          <MDBBtn
            color="default"
            rounded
            size="sm"
            onClick={() => handleViewDetalhes(row)}
          >
            <img src="/images/view.png" width="18px" />
          </MDBBtn>

          <MDBBtn
            color="default"
            rounded
            size="sm"
            onClick={() => handleViewArquivos(row, row.sefa_new)}
          >
            <img src="/images/detalhamento.png" width="18px" />
          </MDBBtn>
        </>
      );
    }
    const buttonFormatterArquivo = (cell, row) => {
      return (
        <>
          <MDBBtn
            color="default"
            rounded
            size="sm"
            onClick={() => handleDownloadArquivo(row, this.obs.sefa_new)}
          >
            <img src="/images/download.svg" />
          </MDBBtn>
        </>
      );
    }

    let agendamentos = SefaStore.obs.index_agendamentos?.map(values => {
      return ({
        descricao: values.descricao,
        periodo: values.periodo.toUpperCase(),
        dia: values.periodo == "semanal" ? getDiaSemana(values.dia).toLocaleUpperCase() : "",
        itens: values
      })
    })

    function buttonFormatterDetalhesAgend(cell, row) {
      return (
        <>
          <MDBBtn
            color="default"
            rounded
            size="sm"
            onClick={() => handleViewDetalhesAgend(row.itens)}
          >
            <img src="/images/edit.png" width="18px" />
          </MDBBtn>
          <MDBBtn
            color="default"
            rounded
            size="sm"
            onClick={() => handleDeleteAgendamento(row.itens)}
          >
            <img src="/images/bin.png" width="18px" />
          </MDBBtn>
        </>
      );
    }

    const handleViewDetalhesAgend = async (row: any) => {

      this.obs.open_create_agendamento = true
      this.obs.agendamento.periodo_selecionado = row.periodo
      this.obs.agendamento.dia = row.dia
      this.obs.agendamento.listEmpresas = row.empresas
      this.obs.agendamento.descricao = row.descricao
      this.obs.agendamento.id = row._id
    };

    const handleDeleteAgendamento = async (row: any) => {

      await SefaStore.handleDeleteAgendamento(row._id)

    };

    function geradoFormatter(cell, row) {
      switch (row.automatico) {
        case true:
          return <span className="new-tag-nav-new">Automático</span>
        default:
          return <span className="new-tag-nav">Manual</span>
      }
    }

    const selectRowProp = {
      mode: "checkbox",
      clickToSelect: true,
      columnWidth: "40px",
      onSelect: this.handleCheckEmpresaChange,
      onSelectAll: this.handleCheckEmpresas,
      selected: this.state.listEmpresas,
    };

    const selectRow = {
      mode: "checkbox",
      clickToSelect: true,
      columnWidth: "40px",
      onSelect: this.handleRowSelect,
      onSelectAll: this.handleRowSelectAll,
      selected: this.obs.agendamento.listEmpresas,
    };

    return (
      <div>

        <Dialog
          isOpen={SefaStore.obs.viewDetalhes}
          onClose={() => SefaStore.obs.viewDetalhes = false}
          title="Dados Solicitações"
          className="dados-soli"
        >
          <div className={Classes.DIALOG_BODY}>
            <div style={{ marginBottom: 10 }}>
              <MDBRow>
                <>
                  <MDBCol md="12">
                    <p>
                      <b>Empresa: </b>
                      {this.obs.errosSefa.nome}
                    </p>
                    <p>
                      <b>CNPJ: </b>
                      {formatCnpj(this.obs.errosSefa.empresa)}
                    </p>
                    <p>
                      <b>CPF: </b>
                      {this.obs.errosSefa.cpf ? this.obs.errosSefa.cpf .toString().replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4") : "N/A"}
                    </p>
                    <p>
                      <b>Criado: </b>
                      {moment(this.obs.errosSefa.data_criacao).format("DD/MM/YYYY") + " " + moment(this.obs.errosSefa.data_criacao).add(3, 'hours').format("HH:mm")}
                    </p>
                    <p>
                      <b>Identificador: </b>
                      {this.obs.errosSefa.uuid ? this.obs.errosSefa.uuid : "N/A"}
                    </p>
                    <p>
                      <b>Erro: </b>
                      {this.obs.errosSefa.erro ? this.obs.errosSefa.erro : "Nenhum erro encontrado!"}
                    </p>
                  </MDBCol>

                  <MDBCol md="12">
                    <h3 className="titleProccess titleCnae">Logs Erros</h3>
                    <div style={{ maxHeight: 200, overflow: "auto" }}>
                      {this.handleErrosTask()}
                    </div>
                  </MDBCol>
                </>
              </MDBRow>
            </div>
          </div>
        </Dialog>

        <Alert
          confirmButtonText="Fechar"
          isOpen={SefaStore.obs.viewArquivos}
          onClose={() => SefaStore.obs.viewArquivos = false}
          canOutsideClickCancel={true}
          className="AlertUser"
        >
          <h2 className="titleSEFAZ">Arquivos</h2>
          <div className="heightArquivos">
            <div style={{ marginBottom: 5, float: "right" }}>
              <Button
                icon="download"
                text="Download Zip"
                loading={TransmissaoStore.obs.loadingArquivoAll}
                className="btn-file btnDefault noMargin"
                onClick={() => handleDownloadAll(this.obs.sefa_new)}
              />
            </div>

            <BootstrapTable
              className="nomeArquivos"
              data={this.obs.arquivosSefa}
              options={options}
              hover
            >
              <TableHeaderColumn dataField="id" isKey={true} hidden width="1%">
                #
              </TableHeaderColumn>
              <TableHeaderColumn dataFormat={buttonFormatterArquivo} width="8%">
              </TableHeaderColumn>
              <TableHeaderColumn dataField="nome" dataSort={true} width="50%">
                Arquivos
              </TableHeaderColumn>
            </BootstrapTable>
          </div>
        </Alert>

        <Dialog
          isOpen={this.obs.verSolicitacoes}
          onClose={() => this.obs.verSolicitacoes = false}
        >
          <h2 className="titleSEFAZ">Histórico de Agendamento</h2>
          <div style={{ height: 400, overflow: "auto" }}>
            <HTMLTable className="table table-hover" style={{ width: "100%" }}>
              <thead>
                <tr>
                  <th style={{ width: 150 }}>Data da Solicitação</th>
                  <th style={{ width: 120 }}>Período Inicial</th>
                  <th style={{ width: 120 }}>Período Final</th>
                  <th style={{ width: 150 }}>CNPJs</th>
                  <th style={{ width: 80 }}>Tipo</th>
                  <th style={{ width: 80, textAlign: "center" }}>Erros</th>
                  <th style={{ width: 80, textAlign: "center" }}>Detalhes</th>
                  <th style={{ width: 80, textAlign: "center" }}>Logs</th>
                </tr>
              </thead>
              <tbody>
                {historico}
              </tbody>
            </HTMLTable>
          </div>

          <MDBRow>
            <MDBCol md="8" className="page-sefa">
              <div style={{ marginTop: 5 }}>
                <Pager
                  currentPage={this.obs.agendamento_page}
                  totalCount={SefaStore.obs.agendamento_length}
                  pageSize={7}
                  onPageChange={page => this.handlePageChangeAgendamento(this.obs.agendamento_page = page)}
                />
              </div>
            </MDBCol>
            <MDBCol md="4">
              <Button text="Fechar" onClick={() => this.onCloseSolicitacoes()} style={{ marginTop: "30px", float: "right" }} />
            </MDBCol>
          </MDBRow>
        </Dialog>

        <Dialog
          isOpen={SefaStore.obs.detalhesSolicitacao}
          onClose={() => SefaStore.obs.detalhesSolicitacao = false}
        >
          <h2 className="titleSEFAZ">Detalhes da Solicitação</h2>

          <MDBRow>
            <MDBCol md="10">
              <FormGroup className="empresaSelect" label="Empresa">
                <EmpresaSelect
                  items={EmpresaStore.sortedEmpresas}
                  itemRenderer={renderEmpresa}
                  itemPredicate={filterEmpresa}
                  onItemSelect={(e: IEmpresa) => this.handleFilterSolicitacoesEmpresa(e)}
                  inputProps={{ placeholder: "Filtrar uma empresa" }}
                >
                  <Button
                    text={empresaTextDetalhes}
                    rightIcon="double-caret-vertical"
                    alignText={Alignment.LEFT}
                  />
                </EmpresaSelect>
              </FormGroup>
            </MDBCol>
            <MDBCol>
              <img src="/images/block.png" width={25} style={{ marginTop: 30, cursor: "pointer" }} onClick={() => this.onClearEmpresa()} />
            </MDBCol>
          </MDBRow>

          <div style={{ width: 1100, height: 350, overflow: "auto" }}>
            <HTMLTable className="table table-hover" style={{ width: "100%" }}>
              <thead>
                <tr>
                  <th style={{ width: 200 }}>Empresa</th>
                  <th style={{ width: 200 }}>Apelido</th>
                  <th style={{ width: 100 }}>CNPJ</th>
                  <th style={{ width: 130 }}>Período</th>
                  <th style={{ width: 100 }}>Status</th>
                  <th style={{ width: 70 }}>Detalhes</th>
                  <th style={{ width: 30 }}></th>
                </tr>
              </thead>
              <tbody>
                {detalhes}
              </tbody>
            </HTMLTable>
          </div>
          <MDBRow>
            <MDBCol md="8" className="page-sefa">
              <div style={{ marginTop: 5 }}>
                <Pager
                  currentPage={this.obs.detalhes_page}
                  totalCount={SefaStore.obs.detalhes_length}
                  pageSize={6}
                  onPageChange={page => this.handlePageChangeDetalhes(this.obs.detalhes_page = page)}
                />
              </div>
            </MDBCol>
            <MDBCol md="4">
              <Button text="Fechar" onClick={() => this.onCloseDetalhesSolicitacoes()} style={{ marginTop: "30px", float: "right" }} />
            </MDBCol>
          </MDBRow>
        </Dialog>

        <Alert
          confirmButtonText="Fechar"
          intent="warning"
          isOpen={this.obs.open_logs}
          onClose={() => this.obs.open_logs = false}
          canOutsideClickCancel={true}
        >
          <h2 className="titleSEFAZ">Histórico de Logs</h2>
          <div className="heightAuto">
            <HTMLTable className="table table-hover" style={{ width: "100%" }}>
              <thead>
                <tr>
                  <th style={{ width: 250 }}>Razão Social</th>
                  <th style={{ width: 150 }}>CNPJ</th>
                  <th style={{ width: 400 }}>ERRO</th>
                </tr>
              </thead>
              <tbody>
                {logs}
              </tbody>
            </HTMLTable>
          </div>
        </Alert>

        <Dialog
          isOpen={this.obs.programarSolicitacoes}
          onClose={() => this.handleCloseProgramar()}
          className="AlertUser modalSefa"
        >
          <h2 className="titleSEFAZ modal-sefa">Programar Solicitação</h2>

          <p style={{ color: "rgba(255, 0, 0, 0.82)" }}>
            <b>Observação:</b> Os arquivos baixados da SEFA permanecem disponíveis no sistema por 90 dias. <br /> Após esse período, será necessário realizar uma nova solicitação para acessá-los.
          </p>

          <FormGroup label="Realizar neste momento:">
            <input
              type="checkbox"
              defaultChecked={this.obs.agora}
              className="chaves"
              onChange={() => {
                this.obs.agora = !this.obs.agora
                this.setState({ dateRealizaDia: null, dateRealizar: "" });
              }}
            />
          </FormGroup>
          {!this.obs.agora &&
            (
              <FormGroup
                label="Realizar dia:"
                className="inputsPeriodoCalculos"
              >
                <DateInput
                  {...getMomentFormatter("DD/MM/YYYY")}
                  locale="pt-br"
                  dayPickerProps={dayPickerProps}
                  placeholder="DD/MM/AAAA"
                  onChange={this.handleDateRealizarChange}
                  value={this.state.dateRealizaDia}
                  canClearSelection
                />
              </FormGroup>
            )}
          <FormGroup
            label="Período de Solicitação:"
            className="inputsPeriodoCalculos"
          >
            <DateRangePickerSped
              onChange={this.handleDateSolicitacaoChange}
              value={this.obs.selectedPeriodSolicitacao}
            />
          </FormGroup>
          <FormGroup
            label="Selecione as Empresas:"
            labelFor="empresas"
          >
            <div className="select-empresa-sefa">
              <BootstrapTable data={empresas} selectRow={selectRowProp} options={options_soli} search>
                <TableHeaderColumn dataField="cnpj" isKey={true} hidden width="0%">#</TableHeaderColumn>
                <TableHeaderColumn dataField="razao_social" width="65%">Razão Social</TableHeaderColumn>
                <TableHeaderColumn dataField="cnpj_formated" width="20%">CNPJ</TableHeaderColumn>
              </BootstrapTable>
            </div>

          </FormGroup>

          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button text="Cancelar" onClick={() => this.handleCloseProgramar()} />
            <Button text="Programar" intent="primary" onClick={() => this.handleProgramarSolicitacoes()} />
          </div>
        </Dialog>

        <Dialog
          isOpen={this.obs.open_agendamentos}
          onClose={() => this.obs.open_agendamentos = false}
          className="AlertUser modal-agendamento"
        >
          <h2 className="titleSEFAZ">Agendamentos</h2>

          {SefaStore.obs.length_agendamentos == 0 &&
            <MDBRow>
              <MDBCol>
                <MDBBtn
                  className="btnDefault btnBuscarNfe" onClick={() => this.obs.open_create_agendamento = true}>
                  Criar Agendamento
                </MDBBtn>
              </MDBCol>
            </MDBRow>
          }

          <div style={{ height: 400, overflow: "auto", marginTop: 10 }}>
            <BootstrapTable className="" data={agendamentos}>
              <TableHeaderColumn dataField="id" isKey={true} hidden width="1%">#</TableHeaderColumn>
              <TableHeaderColumn dataField="descricao" width="50%">Descrição</TableHeaderColumn>
              <TableHeaderColumn dataField="periodo" width="15%">Período</TableHeaderColumn>
              <TableHeaderColumn dataField="dia" width="15%">Dia</TableHeaderColumn>
              <TableHeaderColumn dataFormat={buttonFormatterDetalhesAgend} width="15%">Detalhes</TableHeaderColumn>
            </BootstrapTable>
          </div>

          <MDBRow>
            <MDBCol md="8" className="page-sefa">
              <div style={{ marginTop: 5 }}>
                <Pager
                  currentPage={SefaStore.obs.page_agendamentos}
                  totalCount={SefaStore.obs.length_agendamentos}
                  pageSize={5}
                  onPageChange={page => this.handlePageAgendamento(SefaStore.obs.page_agendamentos = page)}
                />
              </div>
            </MDBCol>
            <MDBCol md="4">
              <Button text="Fechar" intent="primary" onClick={() => this.obs.open_agendamentos = false} style={{ marginTop: "30px", float: "right" }} />
            </MDBCol>
          </MDBRow>

        </Dialog>

        <Dialog
          isOpen={this.obs.open_create_agendamento}
          onClose={() => this.handleCloseAgendamento()}
        >
          {this.obs.agendamento.id == ""
            ? <h2 className="titleSEFAZ">Criar Agendamento</h2>
            : <h2 className="titleSEFAZ">Editar Agendamento</h2>
          }

          <FormGroup className="form-group" label="Descrição">
            <InputGroup type="text" onChange={(e: any) => this.obs.agendamento.descricao = e.target.value} value={this.obs.agendamento.descricao} />
          </FormGroup>

          <div style={{ display: "flex" }}>

            <FormGroup label="Período de comunicação" style={{ width: this.obs.agendamento.periodo_selecionado == "semanal" ? "50%" : "100%" }}>
              <select
                onChange={(e) => {
                  this.obs.agendamento.periodo_selecionado = e.target.value
                  this.obs.agendamento.dia = ""
                }}
                value={this.obs.agendamento.periodo_selecionado}
                className="bp3-button bp3-align-left"
              >
                <option disabled value="">Selecione uma opção</option>
                <option value={"semanal"}>Semanal</option>
                <option value={"quinzenal"}>Quinzenal</option>
                <option value={"mensal"}>Mensal</option>
              </select>
            </FormGroup>

            {this.obs.agendamento.periodo_selecionado == "semanal" &&

              <FormGroup label="Selecione dia" style={{ width: "50%", marginLeft: 10 }}>
                <select onChange={(e) => this.obs.agendamento.dia = e.target.value} value={this.obs.agendamento.dia} className="bp3-button bp3-align-left">
                  <option disabled value={""}>Selecione uma opção</option>
                  <option value={"7"}>Domingo</option>
                  <option value={"1"}>Segunda-feira</option>
                  <option value={"2"}>Terça-feira</option>
                  <option value={"3"}>Quarta-feira</option>
                  <option value={"4"}>Quinta-feira</option>
                  <option value={"5"}>Sexta-feira</option>
                  <option value={"6"}>Sábado</option>
                </select>
              </FormGroup>
            }

          </div>
          <FormGroup label="Empresas" style={{ width: "100%" }}>
            <div className="select-empresa-sefa sefa-agendamento">
              <BootstrapTable data={empresas} selectRow={selectRow} options={options_agendamentos} search>
                <TableHeaderColumn dataField="cnpj" isKey={true} hidden width="1%">#</TableHeaderColumn>
                <TableHeaderColumn dataField="razao_social" width="75%">Razão Social</TableHeaderColumn>
                <TableHeaderColumn dataField="cnpj_formated" width="20%">CNPJ</TableHeaderColumn>
              </BootstrapTable>
            </div>

          </FormGroup>

          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button text="Cancelar" onClick={() => this.handleCloseAgendamento()} />
            <Button text="Salvar" intent="primary" onClick={() => this.handleCreateAgendamento()} />
          </div>
        </Dialog>

        <Dialog
          isOpen={this.obs.open_view_img}
          onClose={() => this.obs.open_view_img = false}
        >
          <div className={Classes.DIALOG_BODY} style={{textAlign: "center"}}>
            <img
              src={this.obs.link_img}
              alt="Imagem indisponível"
              style={{ maxWidth: '100%', height: 'auto' }}
            />
          </div>
          <div className={Classes.DIALOG_FOOTER} style={{textAlign: "center", fontWeight: "bold"}}>
            {this.obs.msg_erro}
          </div>
        </Dialog>

        <MDBRow>
          <MDBCol xl="8" lg="8" md="8" sm="8" xs="8">
            <MDBRow>
              <MDBCol xl="5" lg="5" md="5" sm="5" xs="5">
                <FormGroup className="empresaSelect" label="Empresa">
                  <EmpresaSelect
                    items={EmpresaStore.sortedEmpresas}
                    itemRenderer={renderEmpresa}
                    itemPredicate={filterEmpresa}
                    onItemSelect={(e: IEmpresa) => this.obs.selectedEmpresa = e}
                    inputProps={{ placeholder: "Filtrar uma empresa" }}
                  >
                    <Button
                      text={empresaText}
                      rightIcon="double-caret-vertical"
                      alignText={Alignment.LEFT}
                    />
                  </EmpresaSelect>
                </FormGroup>
              </MDBCol>
              {!this.obs.is_dataDownload
                ? (
                  <MDBCol xl="4" lg="4" md="4" sm="4" xs="4">
                    <FormGroup label="Período de agendamento" className="inputsPeriodoCalculos">
                      <DateRangePicker
                        onChange={this.handleDateChange}
                        value={this.obs.selectedPeriod}
                      />
                    </FormGroup>
                  </MDBCol>
                )
                : (
                  <MDBCol xl="4" lg="4" md="4" sm="4" xs="4">
                    <FormGroup
                      style={{ marginRight: -300 }}
                      label="Data Solicitação"
                      className="inputsPeriodoCalculos"
                    >
                      <DateInput
                        {...getMomentFormatter("DD/MM/YYYY")}
                        locale="pt-br"
                        dayPickerProps={dayPickerProps}
                        placeholder="DD/MM/AAAA"
                        onChange={(e) => this.obs.data_download = e}
                        value={this.obs.data_download}
                        canClearSelection
                      />
                    </FormGroup>
                  </MDBCol>
                )}

              <MDBCol xl="2" lg="2" md="2" sm="2" xs="2">
                <MDBBtn
                  className="btnDefault btnBuscarNfe mt25"
                  onClick={this.handleBuscaClick}
                  disabled={niveis_acesso.indexOf("h1") == -1}
                >
                  Buscar
                </MDBBtn>
              </MDBCol>
            </MDBRow>
          </MDBCol>
        </MDBRow>

        <MDBRow>
          <MDBCol md="12" className="btns-Drop" data-tut="manifestacao">
            <MDBBtn
              className="btnDefault btnBuscarNfe"
              onClick={() => {
                this.setState({ listEmpresas: [] })
                this.obs.programarSolicitacoes = true
              }}
              style={{ marginRight: 20 }}
            >
              Programar Solicitação
            </MDBBtn>
            <MDBBtn
              className="btnDefault btnBuscarNfe"
              onClick={() => {
                this.handleOpenHistAgendamentos()
              }}
              style={{ marginRight: 20 }}
            >
              Ver Agendados
            </MDBBtn>
            <MDBBtn
              className="btnDefault btnBuscarNfe"
              onClick={() => this.handleOpenAgendamentos()}>
              Agendamentos
            </MDBBtn>
          </MDBCol>
        </MDBRow>

        <Dialog isOpen={SefaStore.obs.errosSolicitacao} onClose={() => this.onCloseErros()} className="alertErros">
          <h2 className="titleSEFAZ">Erros ocorridos durante a Solicitação</h2>
          <p style={{ marginBottom: 25, marginTop: -25 }}>
            Para as empresas listadas abaixo, será necessário realizar novamente a solicitação.
          </p>

          <div style={{ height: 400, overflow: "auto" }}>
            <ReactJson
              collapsed={false}
              displayDataTypes={false}
              src={this.obs.erros_sefa}
            />
          </div>

          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button text="Fechar" intent="primary" onClick={() => this.onCloseErros()} />
          </div>
        </Dialog>

        <div data-tut="table">
          <BootstrapTable className="TableDefault" ref="table" data={items} options={options} search data-tut="table">
            <TableHeaderColumn dataField="id" isKey={true} hidden width="1%">#</TableHeaderColumn>
            <TableHeaderColumn dataField="nome" width="40%">Razão Social</TableHeaderColumn>
            <TableHeaderColumn dataField="empresa" dataFormat={(cell) => formatCnpj(cell)} width="20%">CNPJ</TableHeaderColumn>
            <TableHeaderColumn dataField="cnpj" hidden searchable width="20%">CNPJ</TableHeaderColumn>
            <TableHeaderColumn dataFormat={this.formatDateAdd} dataField="data_agendamento" width="20%">Data do Agendamento</TableHeaderColumn>
            <TableHeaderColumn dataFormat={this.formatDateAdd} dataField="periodo_inicial" width="15%">Período Inicial</TableHeaderColumn>
            <TableHeaderColumn dataFormat={this.formatDateSubtract} dataField="periodo_final" width="15%">Período Final</TableHeaderColumn>
            <TableHeaderColumn dataFormat={this.formatMS} dataField="ms" width="15%">Duração</TableHeaderColumn>
            <TableHeaderColumn dataFormat={(cell, row) => this.statusFormatter(row, row.sefa_new, { width: "90%" })} width="25%">Status</TableHeaderColumn>
            <TableHeaderColumn dataFormat={geradoFormatter} width="15%">Origem</TableHeaderColumn>
            <TableHeaderColumn dataFormat={buttonFormatterDetalhes} width="15%">Detalhes</TableHeaderColumn>
          </BootstrapTable>
        </div>

        <div style={{ marginTop: 5, float: "right", marginBottom: 120 }}>
          <Pager
            currentPage={this.obs.current_page}
            totalCount={SefaStore.obs.solicitacoesLength}
            pageSize={50}
            onPageChange={page =>
              this.handleBuscaSolicitacoesEmpresa(this.obs.current_page = page)}
          />
        </div>

        <LoadingModal open={SefaStore.obs.loadingViewArquivo} onClose={() => SefaStore.obs.loadingViewArquivo = false} title={"Abrindo arquivo"} />
        <LoadingModal open={TransmissaoStore.obs.loadingArquivo} onClose={() => TransmissaoStore.obs.loadingArquivo = false} title={"Baixando arquivo"} />
        <LoadingModal open={this.obs.loading_inner} onClose={() => this.obs.loading_inner = false} title={"Carregando"} />
        <LoadingModal open={this.obs.loading} onClose={() => this.obs.loading = false} title={"Carregando"} />

      </div>
    );
  }
}

export default SefaPage;
